import { render, staticRenderFns } from "./RegistrosAnterioresResultados.vue?vue&type=template&id=cb81e58e&scoped=true&"
import script from "./RegistrosAnterioresResultados.vue?vue&type=script&lang=js&"
export * from "./RegistrosAnterioresResultados.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosAnterioresResultados.vue?vue&type=style&index=0&id=cb81e58e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb81e58e",
  null
  
)

export default component.exports